// Import Swiper and modules
import SwiperCore, { Navigation, A11y } from 'swiper/core';
const Swiper = SwiperCore.use([Navigation, A11y]);

function trendingSwiper() {
  const swiperContainer = document.querySelector('.swiper-container');
  if (typeof swiperContainer !== 'undefined' && swiperContainer !== null) {
    // Swiper
    // Install modules
    
    const swiper = new Swiper('.trending__carousel', {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: 5,
          centeredSlides: false,
        }
      }
    });

    // Fixes bug where number of slides on load is incorrect
    document.addEventListener('DOMContentLoaded', () =>{
      swiper.update();
    });
  }
}

export { trendingSwiper };